// src/components/Sidebar.js
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  Home,
  TrendingUp,
  Briefcase,
  CreditCard,
  BookOpen,
  Settings,
  ShoppingBag,
} from "lucide-react";
import wIcon from "../../assets/wealth-compounders.png";
import "./sidebar.css";

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Auto-collapse on tablet view
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024 && window.innerWidth > 768) {
        setIsCollapsed(true);
      } else if (window.innerWidth > 1024) {
        setIsCollapsed(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems = [
    { path: "/dashboard", icon: Home, label: "Dashboard" },
    { path: "/investments", icon: TrendingUp, label: "Investments" },
    { path: "/portfolio", icon: Briefcase, label: "Portfolio" },
    {
      path: "/service-catalogue",
      icon: ShoppingBag,
      label: "Service Catalogue",
    },
    { path: "/transactions", icon: CreditCard, label: "Transactions" },
    { path: "/learning", icon: BookOpen, label: "Learning" },
    { path: "/settings", icon: Settings, label: "Settings" },
  ];

  return (
    <>
      {/* Sidebar Container */}
      <div
        className={`wc-sidebar-container ${
          isCollapsed ? "wc-sidebar-container-collapsed" : ""
        }`}
      >
        {/* Logo Section */}
        <div className="wc-sidebar-logo">
          <div className="wc-sidebar-logo_icon">
            <img
              src={wIcon}
              alt="Wealth Compounders"
              className="wc-sidebar-logo_w-icon"
              loading="lazy"
            />
          </div>
          {!isCollapsed && (
            <div className="wc-sidebar-logo_text">
              <span className="wc-sidebar-logo_wealth">WEALTH</span>
              <span className="wc-sidebar-logo_compounders">COMPOUNDERS</span>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="wc-sidebar-nav" aria-label="Main navigation">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `wc-sidebar-nav_item ${
                  isActive ? "wc-sidebar-nav_item-active" : ""
                }`
              }
              title={isCollapsed ? item.label : ""}
            >
              <item.icon size={20} className="wc-sidebar-nav_icon" />
              {!isCollapsed && (
                <span className="wc-sidebar-nav_label">{item.label}</span>
              )}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Overlay for mobile - if sidebar is open */}
      {!isCollapsed && window.innerWidth <= 768 && (
        <div
          className="wc-sidebar-overlay"
          onClick={() => setIsCollapsed(true)}
        />
      )}
    </>
  );
};

export default Sidebar;
